import { IMPORT_DATA_SOURCE_TYPES } from '../common/SRDataImport/useAuthOptions';

export const UPLOAD_OPTIONS = {
    GOOGLE: 'google',
    MICROSOFT: 'microsoft',
    CSV_OR_EXCEL: 'csvorexel',
    EMAIL_EML: 'email_eml',
    EXISTING_IMPORT: 'existing_import'
};

export const DATA_SOURCE_LABELS = {
    GOOGLE: 'Google account',
    MICROSOFT: 'Microsoft account',
    UPLOAD: 'uploaded file',
    EMAIL: 'email',
    EXISTING_SHORTLIST: 'existing shortlist',
    AI: 'AI'
};

export const ACCOUNTS = 'accounts';

export const DATA_SOURCE_LABEL_BY_IMPORT_SOURCE_TYPE = {
    [IMPORT_DATA_SOURCE_TYPES.GOOGLE]: DATA_SOURCE_LABELS.GOOGLE,
    [IMPORT_DATA_SOURCE_TYPES.MICROSOFT]: DATA_SOURCE_LABELS.MICROSOFT,
    [IMPORT_DATA_SOURCE_TYPES.CSV_OR_EXCEL]: DATA_SOURCE_LABELS.UPLOAD,
    [IMPORT_DATA_SOURCE_TYPES.EMAIL_EML]: DATA_SOURCE_LABELS.EMAIL,
    [IMPORT_DATA_SOURCE_TYPES.EXISTING_IMPORT]: DATA_SOURCE_LABELS.EXISTING_SHORTLIST,
    [IMPORT_DATA_SOURCE_TYPES.AI]: DATA_SOURCE_LABELS.AI
};
